import React, { useState, useEffect, useRef } from 'react';
import marble1 from './image/biji1.png';
import marble2 from './image/biji2.png';
import marble3 from './image/biji3.png';
import marble4 from './image/biji4.png';
import marble5 from './image/biji5.png';
import dropsound from './music/drop.mp3'; 
import anime from 'animejs';

const images = [marble1, marble2, marble3, marble4, marble5];

const Pit = ({ stones, onClick, isHighlighted, currentPlayer, isClicked }) => {
    const [currentStones, setCurrentStones] = useState([]);
    const pitRef = useRef(null);
    const audioRef = useRef(new Audio(dropsound)); 

    useEffect(() => {
        audioRef.current.volume = 0.5;
    }, []);

    useEffect(() => {
       
        if (currentStones.length === 0) {
            initializeStones(stones);
        } else if (stones > currentStones.length) {
            animateStones(stones - currentStones.length);
        } else {
            setCurrentStones(prev => prev.slice(0, stones));
        }
    }, [stones]);

    const initializeStones = (stoneCount) => {
        const initialStones = Array.from({ length: stoneCount }, (_, index) => ({
            id: index,
            image: getRandomImage(),
            position: getRandomPosition(),
        }));
        setCurrentStones(initialStones);
    };

    const animateStones = (newStonesCount) => {
        const newStones = Array.from({ length: newStonesCount }, (_, index) => ({
            id: currentStones.length + index,
            image: getRandomImage(),
            position: getRandomPosition(),
        }));

        setCurrentStones(prev => [...prev, ...newStones]);

        anime({
            targets: pitRef.current.querySelectorAll('.marble.new'),
            scale: [
                { value: 0, duration: 0 },
                { value: 1, duration: 600, easing: 'easeOutElastic(1, .8)' },
            ],
            translateY: [
                { value: -50, duration: 900 },
                { value: 0, duration: 600 },
            ],
            translateX: [
                { value: -50, duration: 1000 },
                { value: 0, duration: 600 },
            ],
            delay: anime.stagger(200),
            begin: () => {
                audioRef.current.play();
            },
            complete: () => {
                pitRef.current.querySelectorAll('.marble.new').forEach(stone => {
                    stone.classList.remove('new');
                });
            },
        });
    };

    const getRandomImage = () => images[Math.floor(Math.random() * images.length)];

    const getRandomPosition = () => {
        const minPosition = 5;
        const maxPosition = 45;
        const top = Math.random() * (maxPosition - minPosition) + minPosition;
        const left = Math.random() * (maxPosition - minPosition) + minPosition;
        return { top, left };
    };

    return (
        <div
            ref={pitRef}
            className={`pit flex justify-center items-center lg:w-32 lg:h-32 ls:h-13 ls:w-13 md:w-20 md:h-20 sm:w-14 sm:h-14 m-2 rounded-full text-white cursor-pointer relative duration-3000 ease-in-out ${isClicked ? (currentPlayer === 1 ? 'border-8 border-[#7327a5]' : 'border-8 border-[#7327a5]') : ''} ${isHighlighted ? 'border-8 border-red-700' : ''}`}
            onClick={onClick}
        >
            <span className="angka-pit flex justify-center items-center sm:h-6 sm:w-6 sm:px-2 sm:py-1 sm:text-sm lg:text-md absolute top-[-1.25rem] text-white font-bold z-0">
                {currentStones.length}
            </span>
            {currentStones.map((stone, index) => {
                const { top, left } = stone.position;
                return (
                    <div
                        key={stone.id}
                        className={`marble lg:w-12 lg:h-12 ls:w-8 ls:h-8 md:h-6 md:w-6 sm:h-6 sm:w-6 bg-cover bg-center rounded-full absolute flex justify-center items-center ${index >= currentStones.length - (stones - currentStones.length) ? 'new' : ''}`}
                        style={{
                            backgroundImage: `url(${stone.image})`,
                            top: `${top}%`,
                            left: `${left}%`,
                        }}
                    />
                );
            })}
        </div>
    );
};

export default Pit;
